<template>
  <div v-if="isRouterAlive">
    <!--搜索、生成-->
    <div class="divBtn">
      <el-input type="text" placeholder="输入商户电话查询二维码" style="width: 200px;" v-model="shopPhone" class="searchInput"
                clearable @clear="selectAll">
      </el-input>
      <el-button icon="el-icon-search" type="primary" @click="searchByPhone">搜索</el-button>
      <el-input type="text" placeholder="输入活动位置查看附近二维码" style="width: 250px;" v-model="activeLocation"
                class="searchInput district" clearable @clear="selectAll">
      </el-input>
      <el-button icon="el-icon-search" type="primary" @click="searchQrcodeByLocation(1)">搜索</el-button>
      <el-select class="el-select-item" v-model="district" clearable placeholder="请选择" @change="changeDistrict"
                 @clear="selectAll">
        <el-option
          v-for="item in area"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <!--数据展示-->
    <el-table
      :data="tableData"
      style="width: 100%;"
      max-height="600"
      empty-text="暂无数据"
      v-loading="loading"
      @selection-change="selectionChange"
      @sort-change="sortChange"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column label="参数" prop="param" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="绑定商户" header-align="center" align="center">
        <template slot-scope="scope">
          <span @click="showMerchant(scope.row)" class="shop-phone">{{scope.row.shopPhone}}</span>
        </template>
      </el-table-column>
      <el-table-column label="激活时间" prop="updateTime" :formatter="formateTime" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="已绑定" sortable header-align="center" align="center">
        <template slot-scope="scope0">
          <el-button type="text" size="small" @click="bindActive(scope0.$index,scope0.row)">{{ scope0.row.activeCount
            }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="累计扫码" sortable header-align="center" align="center">
        <template slot-scope="scope1">
          <el-button type="text" size="small" @click="goDataAnalysis(scope1.$index, scope1.row)">
            <span v-if="scope1.row.scCount==null">0</span>
            <span v-else>{{ scope1.row.scCount}}</span>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="区域" prop="district" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="距离" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.distance&&scope.row.distance<=1000">{{ scope.row.distance }}米</span>
          <span v-else-if="scope.row.distance&&scope.row.distance>1000">{{ scope.row.distance/1000 }}千米</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <!--删除-->
          <el-tooltip :enterable="enterableRes" content="删除" placement="top-start" effect="light">
            <el-button size="mini" type="danger" icon="el-icon-delete"
                       @click="handleDelete(scope.$index, scope.row)" circle></el-button>
          </el-tooltip>
          <!--预览-->
          <el-tooltip :enterable="enterableRes" content="预览" placement="top-start" effect="light">
            <el-button size="mini" type="warning" icon="el-icon-view"
                       @click="viewClick(scope.row)" circle></el-button>
          </el-tooltip>
          <!--下载-->
          <el-tooltip :enterable="enterableRes" content="下载" placement="top-start" effect="light">
            <el-button size="mini" type="primary" icon="el-icon-download"
                       @click="downLoad(scope.row)" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="batch-btn">
      <el-button plain @click="bindInBatches">批量绑定</el-button>
      <el-button plain @click="deleteInBatches">批量删除</el-button>
      <el-button plain @click="downLoadInBatches">批量下载</el-button>
    </div>
    <!--分页按钮-->
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
      @size-change="changeSizeEvn"
      @current-change="handleCurrentChange"
      background>
    </el-pagination>

    <el-dialog top="5vh" title="预览" :visible.sync="viewVisable" width="20%">
      <el-image fit="fill" :src="viewSrc"></el-image>
    </el-dialog>

    <el-dialog title="商家信息" :visible.sync="showShopInfo" width="20%">
      <div>店铺名称：{{this.shopName}}</div>
      <div>联系人：{{this.linkMan}}</div>
      <div>联系电话：{{this.linkPhone}}</div>
      <div>地址：{{this.shopAddress}}</div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showBindActive" width="30%">
      <div><span>以下活动将与{{ this.qrParam }}解除绑定</span></div>
      <el-table :data="actives">
        <el-table-column prop='id' align="left" label="活动id" width="100px"></el-table-column>
        <el-table-column prop='title' align="left" label="活动名称"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBindActive = false">取 消</el-button>
        <el-button type="primary" @click="deleteQrcode">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量绑定活动"
      :visible.sync="qrBindActive"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div>
        <el-form label-width="80px">
          <el-form-item label="活动ID：">
            <div>
              <el-input placeholder="请输入活动ID" v-model="activeId" clearable style="width: 80%"
                        @blur="getActiveInfo(activeId)"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="活动信息"></el-form-item>
          <div v-if="!activeInfo" style="margin-left: 5%">
            <span v-if="!exist">无</span>
            <span v-else>无此活动信息，请重新输入活动ID！</span>
          </div>
          <div v-else v-loading="activeLoading">
            <el-form-item label="活动名称:">
              <span>{{activeTitle}}</span>
            </el-form-item>
            <el-form-item label="活动描述:">
              <span>{{activeDescription}}</span>
            </el-form-item>
            <el-form-item label="活动图片:">
              <img style="width: 30%" :src=activePicture>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BindCancel">取 消</el-button>
        <el-button type="primary" @click="confirmBind">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {area} from './fixation.js'

  export default {
    // inject: ['reload'],
    name: "qrcode",
    data() {
      return {
        area: area,
        district: '',
        certainly: false,
        addIfShow: false,
        ifShow: false,
        updateTempActiveId: '',
        updateActiveDia: false,
        probability: '',
        viewSrc: "",
        viewVisable: false,
        enterableRes: false,
        activeDialogQrLink: '',
        formLabelWidth: '120px',
        resData: '',
        tableData: [],
        totalSize: 0, //总数据条数
        pageSize: 10,//每页条数
        currentPage: 1,//当前页码
        shopPhone: '',
        activeLocation: '',
        activeDia: false,
        addQrContentParam: 0,
        projectId: '',
        qrCodeId: 0,
        certainlyOut: 0,
        isRouterAlive: true,
        shopName: '',
        linkMan: '',
        linkPhone: '',
        shopAddress: '',
        showShopInfo: false,
        showBindActive: false,
        actives: null,
        qrParam: '',
        checkActive: false,
        loading: false,
        selectedRows: [],
        qrBindActive: false,
        activeId: '',
        activeTitle: '',
        activeDescription: '',
        activeInfo: false,
        activePicture: '',
        exist: false,
        activeLoading: false,
        prop: '',
        order: '',
      }
    },
    methods: {
      selectAll() {
        this.loading = true
        let params = {
          "currentPage": this.currentPage - 1,
          "pageSize": this.pageSize,
          "shopPhone": this.shopPhone,
          "district": this.district,
          "prop": this.prop,
          "order": this.order,
        };
        //分页方法
        //发起请求
        this.$http.get(this, '/qrcode/qrList', params).then(res => {
          if (res.code == 200) {
            this.totalSize = res.data.count;
            this.pageSize = res.data.size;
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.$message({
              message: res.message,
              type: "error"
            })
            this.loading = false;
            return
          }
        })
      },
      changeSizeEvn(val) {
        this.pageSize = parseInt(`${val}`)
        if (this.activeLocation) {
          this.searchQrcodeByLocation()
        } else {
          this.selectAll();
        }
      },
      handleCurrentChange(val) {
        this.currentPage = parseInt(`${val}`)
        if (this.activeLocation) {
          this.searchQrcodeByLocation()
        } else {
          this.selectAll();
        }
      },
      async handleDelete(index, row) {
        let that = this
        that.qrParam = row.param
        let qrBindActives = await this.$http.post(this, '/qrcode/active/getProjectByActive', {param: row.qrContentParam})
        this.showBindActive = true
        if (qrBindActives != '' && null != qrBindActives) {
          that.actives = qrBindActives.data
        }
      },
      viewClick(row) {
        if (row.picAddress != null) {
          this.viewVisable = true;
          this.viewSrc = row.picAddress;
        } else {
          this.$message.error("未找到该图片~")
        }
      },
      downLoad(row) {
        //加lodding效果
        const loading = this.$loading({
          text: '码农哥哥正在努力下崽中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let url = row.picAddress
        var request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = 'blob';
        request.onload = function (e) {
          var url = window.URL.createObjectURL(request.response)
          var a = document.createElement('a');
          a.href = url
          a.download = row.qrContentParam + ".png"; //下载后的文件名
          a.click()
        }
        request.send();
        loading.close();
        this.$message.success("图片已下载成功,请查收~");
      },
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },
      formateTime(row) {
        if (!row.updateTime) {
          return '';
        }
        return new Date(row.updateTime).format("yyyy/MM/dd hh:mm");
      },
      changeDistrict() {
        if (this.district != '' && null != this.district) {
          this.pageSize = 10
          this.currentPage = 1
          this.shopPhone = ''
          this.activeLocation = ''
          this.selectAll()
        }
      },
      showMerchant(row) {
        this.shopName = row.shopName
        this.linkMan = row.proposer
        this.linkPhone = row.shopPhone
        this.shopAddress = row.district + row.shopAddress
        this.showShopInfo = true
      },
      deleteQrcode() {
        this.$http.post(this, '/qrcode/deleteByParam', {param: this.qrParam})
        this.showBindActive = false
      },
      selectionChange(selection) {
        this.selectedRows = selection
      },
      deleteInBatches() {
        this.loading = true
        let params = []
        this.selectedRows.forEach(row => {
          params.push(row.param)
        })
        if (params.length > 0) {
          this.$http.post(this, '/qrcode/deleteInBatches', {}, params).then(res => {
            this.loading = false
            this.selectAll()
          })
          this.loading = false
        } else {
          this.loading = false
          return
        }
      },
      downLoadInBatches() {
        this.selectedRows.forEach(row => {
          this.downLoad(row)
        })
      },
      getActiveInfo(activeId) {
        if (activeId == '' || null == activeId) {
          this.$message({
            message: '请输入活动ID！',
            type: "info"
          })
          this.exist = false
        } else {
          this.activeLoading = true
          this.$http.get(this, '/project/' + activeId).then(res => {
            if (res && res.data) {
              this.activeTitle = res.data.title
              this.activeDescription = res.data.description
              this.activePicture = res.data.resource
              this.activeInfo = true
              this.exist = true
            } else {
              this.activeTitle = ''
              this.activeDescription = ''
              this.activePicture = ''
              this.activeInfo = false
              this.exist = true
            }
            this.activeLoading = false
          })
        }
      },
      bindInBatches() {
        if (this.selectedRows.length == 0) {
          this.$message({
            message: '请选择要绑定活动的二维码！',
            type: "error"
          })
          return
        }
        this.qrBindActive = true

      },
      confirmBind() {
        if (!this.exist) {
          this.$message({
            message: '请输入正确的活动ID!',
            type: "error"
          })
          return;
        }
        let params = []
        this.selectedRows.forEach(row => {
          params.push(row.qrContentParam)
        })
        if (this.activeId == '' || this.activeId == null) {
          this.$message({
            message: '请输入活动ID！',
            type: "error"
          })
          return
        }
        this.$http.post(this, '/qrcode/bulkBinding', {activeId: this.activeId}, params).then(res => {
          if (res.listB.length > 0) {
            this.$notify({
              title: '提示',
              message: '二维码:' + res.listB + '  已经绑定此活动！',
              duration: 0,
              type: "error"
            });
          }
          if (res.listA.length > 0) {
            this.$notify({
              title: '提示',
              message: '二维码:' + res.listA + '  添加活动成功！',
              duration: 0,
              type: "success"
            });
          }
        })
        this.qrBindActive = false
        this.activeId = ''
        this.activeInfo = false
        this.exist = false
        this.selectAll()
      },
      BindCancel() {
        this.qrBindActive = false
        this.activeId = ''
        this.activeInfo = false
        this.exist = false
      },
      searchQrcodeByLocation(val) {
        if (val == 1) {
          this.currentPage = 1
        }
        this.district = ''
        this.shopPhone = ''
        if (this.activeLocation != '' && null != this.activeLocation) {
          this.loading = true
          this.$http.post(this, '/qrcode/searchQrcodeByLocation', {
            currentPage: this.currentPage - 1,
            pageSize: this.pageSize,
            activeLocation: this.activeLocation
          }).then(res => {
            if (res && res.data) {
              this.totalSize = res.data.count;
              this.pageSize = res.data.size;
              this.currentPage = res.data.page + 1
              this.tableData = res.data.data;
              this.loading = false
            }
          })
        }
      },
      searchByPhone() {
        this.activeLocation = ''
        this.district = ''
        this.pageSize = 10
        this.currentPage = 1
        this.selectAll()
      },
      sortChange(column) {
        this.prop = column.prop
        this.order = column.order
        this.selectAll()
      },
      bindActive(index, row) {
        this.$router.push({path: '/qrcode/activelist', query: {param: row.param}});
      },
      goDataAnalysis(index, row) {
        this.$router.push({path: '/qrcode/dataanalysis', query: {param: row.param}});
      },
    },
    created() {
      this.selectAll()
    }

  }
</script>

<style scoped>
  .divBtn {
    text-align: left;
    margin-top: 1%;
    margin-left: 3%;
  }

  .searchInput {
    height: 33px;
    margin-right: 1%;
    border-radius: 6px;
    border: 1px solid #cccccc;
  }

  .district {
    width: 200px;
    margin-left: 1%;
  }

  .el-select-item {
    margin-left: 1%;
  }

  input::-webkit-input-placeholder {
    text-align: center;
  }

  .batch-btn {
    margin: 1% 5%;
  }

  .input-with-select {
    background-color: #fff;
  }

  .percent-symbol {
    margin-left: 1%;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.5);
  }

  .shop-phone {
    color: #3399FF;
  }

  .location-condition {
    display: inline-block;
  }
</style>
